/**
 * PlayProjectError - typed error for SDK API failures.
 *
 * Preserves the HTTP status, error code, and response body so callers can
 * distinguish 404 from 429 from 500, surface field-level validation
 * errors, and implement retry logic.
 */
export class PlayProjectError extends Error {
    status;
    code;
    body;
    constructor(message, status, code, body) {
        super(message);
        this.status = status;
        this.code = code;
        this.body = body;
        this.name = 'PlayProjectError';
        Object.setPrototypeOf(this, PlayProjectError.prototype);
    }
    /** True for 429 and 5xx responses — safe to retry with backoff. */
    get isRetryable() {
        return this.status === 429 || this.status >= 500;
    }
    /** Extract Retry-After hint from rate-limit response body if present. */
    get retryAfterSeconds() {
        if (this.body && typeof this.body === 'object') {
            const value = this.body.retry_after_seconds;
            if (typeof value === 'number' && Number.isFinite(value) && value >= 0) {
                return value;
            }
        }
        return undefined;
    }
}
